import React from 'react';

/**
 * BBBSeal
 * ───────
 * BBB's official seal image (https://seal-mbc.bbb.org/logo/ruvtbul/...png)
 * is actually a CSS sprite: the left half is the BBB icon (small), the
 * right half is the accreditation date. BBB's legacy.js script ships a CSS
 * block that crops the sprite to the icon by default and reveals the date
 * on hover via `margin-left:-80px`.
 *
 * That script uses `document.write` which breaks after initial page load
 * (every SPA navigation would white-screen the page). So we port the exact
 * CSS rules into `App.css` (class names `.bbb-seal` / `.ruvtbul`) and
 * render plain markup here — works for unlimited instances per page, no
 * external script, no SPA issues.
 *
 * The wrapper class `.bbb-seal` is responsible for:
 *   • fixed 80×144 box that crops the sprite to the BBB icon only
 *   • overflow hidden so the date half stays clipped at rest
 *   • on :hover, the inner <img> shifts left by 80px to reveal the date
 *
 * Marked `data-cms-skip` so the UniversalTextEditor never tries to make the
 * seal's container editable.
 */

const BBB_PROFILE_URL =
  'https://www.bbb.org/ca/bc/vancouver/profile/information-technology-services/click-one-msp-0037-2439100/#sealclick';
const BBB_IMG_URL = 'https://seal-mbc.bbb.org/logo/ruvtbul/bbb-2439100.png';

const BBBSeal = ({ className = '' }) => (
  <a
    href={BBB_PROFILE_URL}
    target="_blank"
    rel="nofollow noopener noreferrer"
    aria-label="Click One MSP BBB Business Review — hover for accreditation details"
    data-testid="trust-badge-bbb"
    data-cms-skip
    className={`bbb-seal ruvtbul ${className}`}
  >
    <img
      src={BBB_IMG_URL}
      alt="Click One MSP BBB Business Review"
      loading="lazy"
    />
  </a>
);

export default BBBSeal;
